import script from "./Webgl.vue?vue&type=script&lang=ts&setup=true"
export * from "./Webgl.vue?vue&type=script&lang=ts&setup=true"

import "./Webgl.vue?vue&type=style&index=0&id=5cee6146&lang=scss"

const __exports__ = script;

export default __exports__